import React from "react";
import { StepProps } from "../../types";
import { Insurely } from "components/Signup/components/Insurely";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { updateInsuranceById } from "components/Signup/store/slices/animals";
import { useCurrentInsuranceByAnimalId } from "components/Signup/store/selectors/insurance";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";

const FetchCurrentInsurance = ({ next }: StepProps) => {
  const dispatch = useSignupDispatch();
  const { id } = useCurrentAnimal();
  const insurance = useCurrentInsuranceByAnimalId(id);

  return (
    <>
      <div style={{ justifyContent: "center", display: "flex" }}>
        <Insurely
          onComplete={(items) => {
            if (items.length > 0) {
              dispatch(
                updateInsuranceById(
                  {
                    id: insurance.id,
                    update: {
                      insurely: {
                        ...insurance.insurely,
                        policies: items,
                      },
                    },
                  },
                  { refetch: false }
                )
              );
              next();
            }
          }}
        />
      </div>
    </>
  );
};

export default FetchCurrentInsurance;
